import {
  call,
  CallEffect,
  put,
  PutEffect,
  select,
  SelectEffect,
} from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { clearString } from "@/utils/functions";
import { Action } from "redux-saga";
import { automaticApi } from "@/settings/api";
import { setCustomer } from "@/redux/ducks/customer";
import { ReducersTypes } from "@/redux/reducers/Models";

export interface Fetch {
  address: {
    zipcode: string;
    streetName: string;
    number: string;
    neighborhood: string;
    city: string;
    stateName: string;
    complement?: string;
  };
  callback: (success: boolean) => void;
}

export interface UpdateAddressAction {
  type: string;
  payload: Fetch;
}

const uriUpdateAddress = "/customer/v1/address";
const uriCustomerAccount = "/customer/v1/account";

const getCustomerReducer = (state: ReducersTypes) => state.customerReducer;

function buildLocalAddress(payload: Fetch["address"]) {
  return {
    type: { name: "RESIDENCIAL" },
    zipcode: clearString(payload.zipcode),
    streetName: payload.streetName,
    number: payload.number,
    complement: payload.complement ?? "",
    neighborhood: payload.neighborhood,
    city: payload.city,
    state: {
      id: null as string | null,
      name: payload.stateName,
    },
    main: true,
  };
}

export default function* updateAddress({
  payload,
}: UpdateAddressAction): Generator<
  CallEffect<unknown> | PutEffect<Action> | SelectEffect,
  void,
  AxiosResponse & ReducersTypes["customerReducer"]
> {
  try {
    const bodyAddress = {
      address: {
        typeAddress: "RESIDENCIAL",
        zipCode: clearString(payload.address.zipcode),
        street: payload.address.streetName,
        number: payload.address.number,
        neighborhood: payload.address.neighborhood,
        city: payload.address.city,
        state: payload.address.stateName,
        complement: payload.address.complement || null,
      },
    };

    const responseAddress = yield call(
      automaticApi.put,
      uriUpdateAddress,
      bodyAddress,
    );
    const customerAddressSuccess: boolean =
      responseAddress.data?.status?.codigoRetorno === 0;

    if (!customerAddressSuccess) {
      yield call(payload.callback, false);
      return;
    }

    const customer: ReducersTypes["customerReducer"] =
      yield select(getCustomerReducer);

    try {
      const responseData = yield call(automaticApi.get, uriCustomerAccount);
      const data = responseData?.data;

      if (
        data &&
        !data?.errorMessage &&
        data?.serviceMessage?.codigoRetorno === 0
      ) {
        yield put(
          setCustomer({
            client: {
              ...data?.client,
              registrationDate: data?.client?.registrationDate?.split("T")[0],
            },
            account: {
              ...data?.account,
              blockedType: data?.account?.blockedType ?? "",
            },
          }),
        );
      } else {
        yield put(
          setCustomer({
            client: {
              ...customer?.client,
              addresses: [buildLocalAddress(payload.address)],
            },
          }),
        );
      }
    } catch {
      yield put(
        setCustomer({
          client: {
            ...customer?.client,
            addresses: [buildLocalAddress(payload.address)],
          },
        }),
      );
    }

    yield call(payload.callback, true);
  } catch (err) {
    yield call(payload.callback, false);
  }
}
